// utils.js
const checkEmail = (email) => {         // 验证邮箱格式是否正确
    const reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return reg.test(email);
}

const checkDevice = () => {     // 判断用户设备类型
    const deviceAgent = navigator.userAgent.toLowerCase();
    const agentID = deviceAgent.match(/mobile|android|iphone|ipad|phone/i);
    if(agentID){;
        return 'mobile'
    }else{
        return 'pc'
    }
}

const formatTime = (time) => {
    let year = new Date(time).getFullYear()
    let month = new Date(time).getMonth() + 1
    let date = new Date(time).getDate()

    if(month < 10) {
        month = `0${month}`
    }
    if(date < 10) {
        date = `0${date}`
    }

    return `${year}.${month}.${date}`;
}

const perLoadImg = (imglist, callback) => {
    var images = new Array();
    // 加载图片
    for(let i = 0, len = imglist.length; i < len; i++) {
        var objImg = new Image();
        objImg.src = imglist[i];
        images[i] = objImg;
        
        objImg.onload = function() {
            callback && callback('success');
        }
        objImg.onerror= function() {
            callback && callback('failed');
        }
    }
}

export default {
    checkEmail,
    checkDevice,
    formatTime,
    perLoadImg
}